import { formatCount } from "../../presentation/count";
import "@/components/shared/error-state-motion.css";

export function CountChip({
    count,

    label = "nearby",
}: {
    count: number | undefined | null;
    label?: string;
}) {
    if (count == null || count <= 0) return null;

    return (
        <span
            aria-hidden
            className="count-chip-enter pointer-events-none inline-flex items-center gap-1 whitespace-nowrap"
        >
            <span className="inline-block size-1.5 shrink-0 rounded-full bg-labrador-yellow" />
            <span className="text-caption text-maltese-white/70">
                {formatCount(count)} {label}
            </span>
        </span>
    );
}
